import React from 'react';

import './styles.scss';


import frente1 from '../../assets/img/nosotros/celuba-frente-1.jpg';
import frente2 from '../../assets/img/nosotros/celuba-frente-2.jpg';
import frente3 from '../../assets/img/nosotros/celuba-1.jpg';
import frente4 from '../../assets/img/nosotros/celuba-2.jpg';


const Nosotros = () => {
  return (

    <div className="py-0 py-md-5 service-12">
      <div className="container">
          <div className="row">
              <div className="col-lg-6">
                  <span className="badge badge-info px-3 py-1 font-weight-light">Nosotros</span>
                  <h4 className="my-3">CELÚBA</h4>
                  <h6 className="font-weight-light subtitle">Tu Tienda de Celulares en Bahía Blanca</h6>
                  <div className="row">
                      <div className="col-md-12 mt-3">
                          <p>¡Bienvenido a CELÚBA, el lugar donde la tecnología y la atención personalizada se encuentran! Somos una tienda especializada en celulares, accesorios y servicios, ubicada en Bahía Blanca, Provincia de Buenos Aires. Nos enorgullece ser parte de tu comunidad y ayudarte a encontrar el dispositivo perfecto que se adapte a tu estilo de vida.</p>
                      </div>
                      <div className="col-md-6 mt-3">
                          <h6 className="font-weight-medium">¿Qué vas a encontrar en CELÚBA?</h6>
                          <ul>
                            <li>Últimos modelos de celulares: Trabajamos con las principales marcas del mercado como Samsung, Motorola, Xiaomi, Apple y más.</li>
                            <li>Accesorios para tu celular: Auriculares, fundas, cargadores, vidrios templados y todo lo que necesitas para personalizar y proteger tu dispositivo.</li>
                            <li>Reparación y mantenimiento: ¿Pantalla rota? ¿Problemas con la batería? Contamos con servicio técnico especializado para mantener tu celular como nuevo.</li>
                            <li>Planes y financiación: Te ofrecemos las mejores opciones de pago y cuotas sin interés, para que estrenar tu celular sea más fácil que nunca.</li>
                          </ul>
                      </div>
                      <div className="col-md-6 mt-3">
                          <h6 className="font-weight-medium">Por qué elegir CELÚBA</h6>
                          <ul>
                            <li>Atención personalizada: Nuestro equipo está listo para asesorarte y responder todas tus preguntas. Queremos que encuentres el equipo ideal para vos.</li>
                            <li>Precios accesibles: Con ofertas y promociones para cada bolsillo.</li>
                            <li>Soporte posventa: No solo vendemos, también te acompañamos después de la compra</li>
                          </ul>
                      </div>
                      <div className="col-md-12 mt-3">
                          <h6 className="font-weight-medium">Visitanos en Bahía Blanca</h6>
                          <p>Acercate a nuestros locales y viví la experiencia <strong>CELÚBA</strong>. Descubrí las novedades en tecnología móvil y accedé a promociones imperdibles que solo encontrarás en nuestra tienda.</p>
                      </div>
                  </div>
              </div>
              <div className="col-lg-6">
                  <div className="row wrap-service12">
                      <div className="col-md-6">
                          <div className="row">
                              <div className="col-md-12 img-hover mb-4"><img src={frente1} className="rounded img-shadow img-fluid" alt="wrapkit" /></div>
                              <div className="col-md-12 img-hover mb-4"><img src={frente2} className="rounded img-shadow img-fluid" alt="wrapkit" /></div>
                          </div>
                      </div>
                      <div className="col-md-6 uneven-box d-none d-md-block">
                          <div className="row">
                              <div className="col-md-12 img-hover mb-4"><img src={frente3} className="rounded img-shadow img-fluid" alt="wrapkit" /></div>
                              <div className="col-md-12 img-hover mb-4"><img src={frente4} className="rounded img-shadow img-fluid" alt="wrapkit" /></div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>

  );
};

export default Nosotros;
